import { useAlertsStore } from '@shared/hooks/state/AlertsContainer';
import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function useEmailVerificationResend() {
    const { t } = useTranslation();

    const handleResendVerification = useCallback(async () => {
        try {
            const result = await useCurrentUserStore.getState().requestEmailVerificationResend();
            if (result?.resultType === 'Ok') {
                useAlertsStore.getState().showSuccess(t('common:account.isEmailVerified.success'));
            } else {
                useAlertsStore.getState().showError(t('common:account.isEmailVerified.error'));
            }
        } catch (error) {
            useAlertsStore.getState().showError(t('common:account.isEmailVerified.error'));
        }
    }, [t]);

    return { handleResendVerification };
}
